// Access control functions for subscription features

export function canAddPlayer(isPro, currentPlayerCount, isCoach = false) {
  if (isPro || isCoach) return true;
  return currentPlayerCount < 1;
}

export function canAddSeason(isPro, currentSeasonCount, isCoach = false) {
  if (isPro || isCoach) return true;
  return currentSeasonCount < 1;
}

export function canAccessTournaments(isPro, isCoach = false) {
  return isPro || isCoach;
}

export function canAccessTrends(isPro, isCoach = false) {
  return isPro || isCoach;
}

export function getPlayerLimitMessage(isPro, currentPlayerCount, isCoach = false) {
  if (isPro || isCoach) return null;
  if (currentPlayerCount >= 1) {
    return 'Free users are limited to 1 player. Upgrade to Pro for unlimited players!';
  }
  return null;
}

export function getSeasonLimitMessage(isPro, currentSeasonCount, isCoach = false) {
  if (isPro || isCoach) return null;
  if (currentSeasonCount >= 1) {
    return 'Free users are limited to 1 season. Upgrade to Pro for unlimited seasons!';
  }
  return null;
}